module.exports = __webpack_public_path__ + "images/shimo/document-grid-59e885ee5a45591a36ae6088fb9b84ea.png";